import { Button, Div, Flex, Heading } from "@hopper-ui/components";
import { DismissIcon } from "@hopper-ui/icons";
import { useSharedTranslation, useSourcesSidePanelStore } from "@workleap-ai/shared";

interface Props {
    count: number;
}

export const SourcesSidePanelHeader = ({ count }: Props) => {
    const closeMessageSources = useSourcesSidePanelStore(state => state.closeMessageSources);
    const { tShared } = useSharedTranslation();

    return (
        <Div
            padding="inset-md"
            borderBottom="neutral-weakest"
            className="wai-side-panel-card wai-side-panel-item"
            style={{ "--wai-side-panel-item-delay": "0ms" } as React.CSSProperties}
        >
            <Flex
                justifyContent="space-between"
                alignItems="center"
            >
                <Heading>
                    {tShared("sourcesCount", { count })}
                </Heading>
                <Button
                    variant="ghost-secondary"
                    aria-label={tShared("close")}
                    onPress={closeMessageSources}
                >
                    <DismissIcon />
                </Button>
            </Flex>
        </Div>
    );
};

